module.exports = __webpack_public_path__ + "assets/img/b138428ceba7c3844e3a6d0e4a97de32.svg";